export default __webpack_public_path__ + "static/media/1.63d9b910.png";